import { render, staticRenderFns } from "./w-modal.vue?vue&type=template&id=359b70c3&"
import script from "./w-modal.vue?vue&type=script&lang=ts&"
export * from "./w-modal.vue?vue&type=script&lang=ts&"
import style0 from "./w-modal.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports